import React, { useState, useEffect, useContext } from 'react';
import { popupWin } from 'components/PopUps';
import { UmbracoContext, UmbracoStep } from "components/Umbraco/UmbracoContext";
import { CheckValidInputs, useInput, MainCond } from 'meitav-uikit';


import utils from "utils";

export default function DeepLinkComponents(props) {


  const { UmbracoUtills, rest } = utils;

  const resource = useContext(UmbracoContext).resource;
  const resourceError = UmbracoStep(resource, `stepValidation`);
  const resourceUpContact = UmbracoStep(useContext(UmbracoContext).resource,"PopUpContact" );
  const resourceOtp = UmbracoStep(useContext(UmbracoContext).resource,"PopUpOtp" );
  const resourceNotMiddleProcess = UmbracoStep(useContext(UmbracoContext).resource,"PopUpNotMiddleProcess");

  const handleClose = () => {
    window.localStorage.clear();
    window.location.href = "/CustomerInvestPolicy";
  }

  const handleCick = () => {
  window.localStorage.clear()
    window.location.href = "/JoinPersonalDetails";
  }

  useEffect(() => {
    popUpDeeplink();

  }, []);
  const handleLink = () => {
    popUpDeeplink();
  }
  const popUpDeeplink = () => {
    let obj = {};
    obj.type = "deeplink";
    obj.resource =resource;
    obj.resourceUpContact =resourceUpContact;
    obj.resourceOtp =resourceOtp;
    obj.resourceNotMiddleProcess =resourceNotMiddleProcess;
    obj.handleClose = handleClose;
    obj.handleCick = handleCick;
    obj.handleLink = handleLink;
    obj.className = "deeplink";

    popupWin(obj);
  }

  return (
    <>
      <div></div>

    </>
  );
}
